import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig, Text, Heading, Flex, Divider} from '@chakra-ui/react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {parseAndSanitizeJSONWithSpaces} from '../../../utils/utils'
import {FormattedMessage} from 'react-intl'
import useSlideUpAnimation from '../../../custom-hooks/use-slide-up-animation'

const Awards = ({awards, p}) => {
    const styles = useMultiStyleConfig('Awards')
    const awardsItems = awards && parseAndSanitizeJSONWithSpaces(awards, p)
    const {customParams} = getConfig()
    const {containerRef, getAnimProps} = useSlideUpAnimation()

    const baseUrl = `${customParams?.dam?.protocol}://${customParams?.dam?.domain}`

    if (!awardsItems) return <></>

    return (
        <Box {...styles.flexContainer} ref={containerRef}>
            <Flex {...styles.headerContainer}>
                <Heading {...styles.title}>
                    <FormattedMessage
                        id="awards.labels.title"
                        defaultMessage="Excellence made simple"
                    />
                </Heading>
                <Text {...styles.description}>
                    <FormattedMessage
                        id="awards.labels.description"
                        defaultMessage="{awardsItems} global awards"
                        values={{awardsItems: awardsItems.length}}
                    />
                </Text>
            </Flex>

            <Box {...styles.awardsContainer}>
                {awardsItems?.map((item, index) => {
                    const isLastItem = index === awardsItems.length - 1
                    return (
                        <Box {...styles.award} key={index} {...getAnimProps(index)}>
                            <Box {...styles.awardContent}>
                                <Box
                                    background={[
                                        `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                        `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                        `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                        `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                    ]}
                                    {...styles.image}
                                    data-testid="award-image"
                                />
                                <Text {...styles.awardTitle}>{item.title}</Text>
                                <Text {...styles.awardDescription}>{item.description}</Text>
                            </Box>

                            {!isLastItem && <Divider {...styles.divider} />}
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

Awards.propTypes = {
    awards: PropTypes.string,
    p: PropTypes.string,
}

export default Awards
